import { useState } from "react"
import { Search } from "lucide-react"

// Mock products; the real search would hit the products table.
const PRODUCTS = [
  { sku: "HRI-13963", name: "Halio Ion Sonic Pro" },
  { sku: "HRI-13864", name: "Halio Ion Black" },
  { sku: "HSG-13984", name: "Halio Sonic Glow Yellow" },
  { sku: "HRC-12546", name: "Halio Red Light Collagen" },
  { sku: "HRM-13859", name: "Halio Red Light Mask" },
  { sku: "HDT-14142", name: "Halio Daily Toothbrush" },
]

// Product search: fills the top bar between the market block and the bell.
// Typing shows matching products by name or SKU; picking one would open that
// product's page.
export default function ProductSearch() {
  const [query, setQuery] = useState("")
  const [open, setOpen] = useState(false)
  const q = query.trim().toLowerCase()
  const matches = q ? PRODUCTS.filter((p) => p.name.toLowerCase().includes(q) || p.sku.toLowerCase().includes(q)) : []

  return (
    <div className="relative flex h-full flex-1 items-center border-r border-border focus-within:bg-muted/40">
      <Search size={15} className="pointer-events-none absolute left-4 text-muted-foreground" />
      <input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder="Search products by name or SKU"
        className="h-full w-full bg-transparent pl-10 pr-4 text-[13px] text-foreground outline-none placeholder:text-muted-foreground"
      />
      {open && q && (
        <div className="absolute left-0 top-full z-20 w-[480px] rounded-b-md border border-t-0 border-border bg-background py-1 shadow-md">
          {matches.length === 0 ? (
            <div className="px-4 py-2 text-[13px] text-foreground">No products match "{query}"</div>
          ) : (
            matches.map((p) => (
              <button
                key={p.sku}
                type="button"
                className="flex w-full items-center justify-between px-4 py-2 text-left text-[13px] text-foreground hover:bg-muted"
              >
                {p.name}
                <span className="text-xs text-muted-foreground">{p.sku}</span>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  )
}
